// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.banner-alert{\n  width: 100%;\n  background: #fff3cd;\n  border-bottom: 1px solid #ffeeba;\n  color: #856404;\n}\n.banner-inner{\n  max-width: 100%;\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 4px;\n}\n.banner-title{\n  font-weight: 700;\n}\n.banner-message{\n  line-height: 1.3;\n}\n", ""]);
// Exports
module.exports = exports;
